import React, { Component } from 'react'

const liStyle = {
    borderRadius: '50%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
}

const ringStyle = {
    middle: Object.assign({}, liStyle, {
        width: '66%',
        height: '66%',
    }),
    inner: Object.assign({}, liStyle, {
        width: '33%',
        height: '33%',
    }),
}

let generateCacheStyle = ({ outerWidth, outerHeight }) => ({
    outerWidth,
    outerHeight,
    style: Object.assign({}, liStyle, {
        width: `${outerWidth}%`,
        height: `${outerHeight}%`,
    }),
})

class LoadingIndicator extends Component {
    getOuterRingStyle({ outerWidth, outerHeight }) {
        if (
            !this.cacheStyle ||
            this.cacheStyle.outerWidth != outerWidth ||
            this.cacheStyle.outerHeight != outerHeight
        ) {
            this.cacheStyle = generateCacheStyle({ outerWidth, outerHeight })
        }
        return this.cacheStyle.style
    }
    render() {
        const { style = {}, outerSizes = {} } = this.props
        const outerWidth = outerSizes.outerWidth || 75
        const outerHeight = outerSizes.outerHeight || 75
        const colorClass = this.props.class || ''
        return (
            <div
                className="loadingIndicator"
                style={Object.assign(
                    {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        position: 'absolute',
                        zIndex: 3,
                    },
                    this.props.style
                )}
            >
                <div style={style.spinner}>
                    <div className={`outer ${colorClass}`} style={this.getOuterRingStyle({ outerWidth, outerHeight })}>
                        <div className={`middle ${colorClass}`} style={ringStyle.middle} />
                        <div className={`inner ${colorClass}`} style={ringStyle.inner} />
                    </div>
                </div>
            </div>
        )
    }
}

export default LoadingIndicator
